/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/search/search-results.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Component } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { VisionIcsApiService } from "vics/visionics/api/ng/index";
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/platform-browser";
import * as i3 from "vics/visionics/api/ng/index";
import * as i4 from "@angular/material/card";
import * as i5 from "@angular/material/list";
import * as i6 from "@angular/common";
import * as i7 from "@angular/material/core";
import * as i8 from "@angular/material/icon";
const _c0 = function (a1) { return ["/patient", a1]; };
function SearchResultsComponent_ng_container_4_mat_list_item_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-list-item", 3);
    i0.ɵɵelementStart(1, "a", 4);
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "people");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const result_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(6, _c0, result_r16.patient.id));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate5(" ", result_r16.patient.familyName, ", ", result_r16.patient.firstName, " (DOB ", result_r16.patient.dateOfBirth.year, "-", result_r16.patient.dateOfBirth.month, "-", result_r16.patient.dateOfBirth.day, ") ");
} }
const _c1 = function (a1) { return ["/club", a1]; };
function SearchResultsComponent_ng_container_4_mat_list_item_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-list-item", 3);
    i0.ɵɵelementStart(1, "a", 4);
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "people");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const result_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c1, result_r16.club.number));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", result_r16.club.name, " ");
} }
function SearchResultsComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SearchResultsComponent_ng_container_4_mat_list_item_1_Template, 5, 8, "mat-list-item", 2);
    i0.ɵɵtemplate(2, SearchResultsComponent_ng_container_4_mat_list_item_2_Template, 5, 4, "mat-list-item", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const result_r16 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", result_r16.patient);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", result_r16.club);
} }
export class SearchResultsComponent {
    /**
     * @param {?} route
     * @param {?} titleService
     * @param {?} api
     * @param {?} router
     */
    constructor(route, titleService, api, router) {
        this.route = route;
        this.titleService = titleService;
        this.api = api;
        this.router = router;
        this.results = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.titleService.setTitle("Search");
        this.results = this.route.snapshot.data.results.result;
    }
}
SearchResultsComponent.decorators = [
    { type: Component, args: [{
                templateUrl: "search-results.component.html",
            },] },
];
/** @nocollapse */
SearchResultsComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Title },
    { type: VisionIcsApiService },
    { type: Router }
];
/** @nocollapse */ SearchResultsComponent.ɵfac = function SearchResultsComponent_Factory(t) { return new (t || SearchResultsComponent)(i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(i2.Title), i0.ɵɵdirectiveInject(i3.VisionIcsApiService), i0.ɵɵdirectiveInject(i1.Router)); };
/** @nocollapse */ SearchResultsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SearchResultsComponent, selectors: [["ng-component"]], decls: 5, vars: 1, consts: [[1, "full-screen-card"], [4, "ngFor", "ngForOf"], [3, "routerLink", 4, "ngIf"], [3, "routerLink"], ["matLine", ""]], template: function SearchResultsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-card", 0);
        i0.ɵɵelementStart(1, "h1");
        i0.ɵɵtext(2, "Search Results");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "mat-nav-list");
        i0.ɵɵtemplate(4, SearchResultsComponent_ng_container_4_Template, 3, 2, "ng-container", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.results);
    } }, directives: [i4.MatCard, i5.MatNavList, i6.NgForOf, i6.NgIf, i5.MatListItem, i1.RouterLink, i7.MatLine, i8.MatIcon], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SearchResultsComponent, [{
        type: Component,
        args: [{
                templateUrl: "search-results.component.html",
            }]
    }], function () { return [{ type: i1.ActivatedRoute }, { type: i2.Title }, { type: i3.VisionIcsApiService }, { type: i1.Router }]; }, null); })();
if (false) {
    /** @type {?} */
    SearchResultsComponent.prototype.results;
    /**
     * @type {?}
     * @private
     */
    SearchResultsComponent.prototype.route;
    /**
     * @type {?}
     * @private
     */
    SearchResultsComponent.prototype.titleService;
    /**
     * @type {?}
     * @private
     */
    SearchResultsComponent.prototype.api;
    /**
     * @type {?}
     * @private
     */
    SearchResultsComponent.prototype.router;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VhcmNoLXJlc3VsdHMuY29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vdmlzaW9uaWNzL25nL3NyYy9hcHAvc2VhcmNoL3NlYXJjaC1yZXN1bHRzLmNvbXBvbmVudC50cyIsIi4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uL3Zpc2lvbmljcy9uZy9zcmMvYXBwL3NlYXJjaC9zZWFyY2gtcmVzdWx0cy5jb21wb25lbnQuaHRtbCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLE9BQU8sRUFBQyxTQUFTLEVBQUMsTUFBTSxlQUFlLENBQUM7QUFDeEMsT0FBTyxFQUFDLEtBQUssRUFBQyxNQUFNLDJCQUEyQixDQUFDO0FBQ2hELE9BQU8sRUFBQyxjQUFjLEVBQUUsTUFBTSxFQUFDLE1BQU0saUJBQWlCLENBQUM7QUFDdkQsT0FBTyxFQUVMLG1CQUFtQixFQUNwQixNQUFNLDZCQUE2QixDQUFDOzs7Ozs7Ozs7Ozs7SUNBL0Isd0NBQ0U7SUFBQSw0QkFDRTtJQUFBLGdDQUFVO0lBQUEsc0JBQU07SUFBQSxpQkFBVztJQUMzQixZQUVGO0lBQUEsaUJBQUk7SUFDTixpQkFBZ0I7OztJQU5zQiw4RUFBOEM7SUFHaEYsZUFFRjtJQUZFLHNPQUVGOzs7O0lBRUYsd0NBQ0U7SUFBQSw0QkFDRTtJQUFBLGdDQUFVO0lBQUEsc0JBQU07SUFBQSxpQkFBVztJQUMzQixZQUNGO0lBQUEsaUJBQUk7SUFDTixpQkFBZ0I7OztJQUxtQiwrRUFBNEM7SUFHM0UsZUFDRjtJQURFLHFEQUNGOzs7SUFaSiw2QkFDRTtJQUFBLDBHQUNFO0lBTUYsMEdBQ0U7SUFLSiwwQkFBZTs7O0lBYkUsZUFBc0I7SUFBdEIseUNBQXNCO0lBT3RCLGVBQW1CO0lBQW5CLHNDQUFtQjs7QURGeEMsTUFBTSxPQUFPLHNCQUFzQjs7Ozs7OztJQUdqQyxZQUNxQixLQUFxQixFQUNyQixZQUFtQixFQUNuQixHQUF3QixFQUN4QixNQUFjO1FBSGQsVUFBSyxHQUFMLEtBQUssQ0FBZ0I7UUFDckIsaUJBQVksR0FBWixZQUFZLENBQU87UUFDbkIsUUFBRyxHQUFILEdBQUcsQ0FBcUI7UUFDeEIsV0FBTSxHQUFOLE1BQU0sQ0FBUTtRQU5uQyxZQUFPLEdBQXNCLEVBQUUsQ0FBQztJQU83QixDQUFDOzs7O0lBRUosUUFBUTtRQUNOLElBQUksQ0FBQyxZQUFZLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxDQUFDO1FBQ3JDLElBQUksQ0FBQyxPQUFPLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUM7SUFDekQsQ0FBQzs7O1lBaEJGLFNBQVMsU0FBQztnQkFDVCxXQUFXLEVBQUcsK0JBQStCO2FBQzlDOzs7O1lBUk8sY0FBYztZQURkLEtBQUs7WUFJWCxtQkFBbUI7WUFIRyxNQUFNOzs0RkFTakIsc0JBQXNCOzJEQUF0QixzQkFBc0I7UUNYbkMsbUNBQ0U7UUFBQSwwQkFBSTtRQUFBLDhCQUFjO1FBQUEsaUJBQUs7UUFHdkIsb0NBQ0U7UUFBQSx5RkFDRTtRQWNKLGlCQUFlO1FBRWpCLGlCQUFXOztRQWpCTyxlQUE4QjtRQUE5QixxQ0FBOEI7O2tERE1uQyxzQkFBc0I7Y0FIbEMsU0FBUztlQUFDO2dCQUNULFdBQVcsRUFBRywrQkFBK0I7YUFDOUM7Ozs7SUFFQyx5Q0FBZ0M7Ozs7O0lBRzVCLHVDQUFzQzs7Ozs7SUFDdEMsOENBQW9DOzs7OztJQUNwQyxxQ0FBeUM7Ozs7O0lBQ3pDLHdDQUErQiIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7Q29tcG9uZW50fSBmcm9tIFwiQGFuZ3VsYXIvY29yZVwiO1xuaW1wb3J0IHtUaXRsZX0gZnJvbSBcIkBhbmd1bGFyL3BsYXRmb3JtLWJyb3dzZXJcIjtcbmltcG9ydCB7QWN0aXZhdGVkUm91dGUsIFJvdXRlcn0gZnJvbSBcIkBhbmd1bGFyL3JvdXRlclwiO1xuaW1wb3J0IHtcbiAgQXBpU2VhcmNoUmVzdWx0LFxuICBWaXNpb25JY3NBcGlTZXJ2aWNlXG59IGZyb20gXCJ2aWNzL3Zpc2lvbmljcy9hcGkvbmcvaW5kZXhcIjtcblxuQENvbXBvbmVudCh7XG4gIHRlbXBsYXRlVXJsIDogXCJzZWFyY2gtcmVzdWx0cy5jb21wb25lbnQuaHRtbFwiLFxufSlcbmV4cG9ydCBjbGFzcyBTZWFyY2hSZXN1bHRzQ29tcG9uZW50IHtcbiAgcmVzdWx0czogQXBpU2VhcmNoUmVzdWx0W10gPSBbXTtcblxuICBjb25zdHJ1Y3RvcihcbiAgICAgIHByaXZhdGUgcmVhZG9ubHkgcm91dGU6IEFjdGl2YXRlZFJvdXRlLFxuICAgICAgcHJpdmF0ZSByZWFkb25seSB0aXRsZVNlcnZpY2U6IFRpdGxlLFxuICAgICAgcHJpdmF0ZSByZWFkb25seSBhcGk6IFZpc2lvbkljc0FwaVNlcnZpY2UsXG4gICAgICBwcml2YXRlIHJlYWRvbmx5IHJvdXRlcjogUm91dGVyLFxuICApIHt9XG5cbiAgbmdPbkluaXQoKSB7XG4gICAgdGhpcy50aXRsZVNlcnZpY2Uuc2V0VGl0bGUoXCJTZWFyY2hcIik7XG4gICAgdGhpcy5yZXN1bHRzID0gdGhpcy5yb3V0ZS5zbmFwc2hvdC5kYXRhLnJlc3VsdHMucmVzdWx0O1xuICB9XG59XG4iLCI8bWF0LWNhcmQgY2xhc3M9XCJmdWxsLXNjcmVlbi1jYXJkXCI+XG4gIDxoMT5TZWFyY2ggUmVzdWx0czwvaDE+XG5cblxuICA8bWF0LW5hdi1saXN0PlxuICAgIDxuZy1jb250YWluZXIgKm5nRm9yPVwibGV0IHJlc3VsdCBvZiByZXN1bHRzXCI+XG4gICAgICA8bWF0LWxpc3QtaXRlbSAqbmdJZj1cInJlc3VsdC5wYXRpZW50XCIgW3JvdXRlckxpbmtdPVwiWycvcGF0aWVudCcsIHJlc3VsdC5wYXRpZW50LmlkXVwiPlxuICAgICAgICA8YSBtYXRMaW5lPlxuICAgICAgICAgIDxtYXQtaWNvbj5wZW9wbGU8L21hdC1pY29uPlxuICAgICAgICAgIHt7IHJlc3VsdC5wYXRpZW50LmZhbWlseU5hbWUgfX0sIHt7IHJlc3VsdC5wYXRpZW50LmZpcnN0TmFtZSB9fVxuICAgICAgICAgICAgKERPQiB7eyByZXN1bHQucGF0aWVudC5kYXRlT2ZCaXJ0aC55ZWFyIH19LXt7IHJlc3VsdC5wYXRpZW50LmRhdGVPZkJpcnRoLm1vbnRoIH19LXt7IHJlc3VsdC5wYXRpZW50LmRhdGVPZkJpcnRoLmRheSB9fSlcbiAgICAgICAgPC9hPlxuICAgICAgPC9tYXQtbGlzdC1pdGVtPlxuICAgICAgPG1hdC1saXN0LWl0ZW0gKm5nSWY9XCJyZXN1bHQuY2x1YlwiIFtyb3V0ZXJMaW5rXT1cIlsnL2NsdWInLCByZXN1bHQuY2x1Yi5udW1iZXJdXCI+XG4gICAgICAgIDxhIG1hdExpbmU+XG4gICAgICAgICAgPG1hdC1pY29uPnBlb3BsZTwvbWF0LWljb24+XG4gICAgICAgICAge3sgcmVzdWx0LmNsdWIubmFtZSB9fVxuICAgICAgICA8L2E+XG4gICAgICA8L21hdC1saXN0LWl0ZW0+XG4gICAgPC9uZy1jb250YWluZXI+XG4gIDwvbWF0LW5hdi1saXN0PlxuXG48L21hdC1jYXJkPlxuIl19